module.exports = __webpack_public_path__ + "img/computer-speaker.997dad44.svg";